var map = {
	"./CHINAp.webp": 4311,
	"./JORDANp.webp": 9220,
	"./KUWAITp.webp": 1285,
	"./MALASIYAp.webp": 4587,
	"./PAKISTANp.webp": 9300,
	"./QATARp.webp": 1245,
	"./TAIWANp.jpg": 1546,
	"./THAILANDp.webp": 6823,
	"./UAEP.webp": 161,
	"./UKSER.webp": 9588,
	"./VIETNAMp.webp": 1782,
	"./apostille1.jpg": 5402,
	"./bahrain.webp": 4939,
	"./bahrainp.webp": 2141,
	"./birth.jpg": 901,
	"./business-docs.jpg": 3260,
	"./cert1.jpg": 3005,
	"./cert2.jpg": 7074,
	"./cert3.png": 175,
	"./cert4.jpg": 996,
	"./check.jpg": 9614,
	"./china.webp": 6297,
	"./degree.png": 4852,
	"./dhl.webp": 8206,
	"./egypt.webp": 2281,
	"./egyptp.jpg": 4759,
	"./embassy.webp": 7422,
	"./galaxy.jpg": 5864,
	"./gify.gif": 2084,
	"./hands.jpeg": 1625,
	"./homeimage.jpeg": 6863,
	"./india.png": 3195,
	"./indiap.webp": 3331,
	"./jordan.jpg": 5974,
	"./kuwait.png": 1767,
	"./logo.jpg": 1769,
	"./london.webp": 3276,
	"./malaysia.webp": 8553,
	"./pakistan.webp": 4009,
	"./personal-docs.jpg": 6990,
	"./pg.jpg": 6919,
	"./poa.jpg": 4066,
	"./qatar.webp": 5899,
	"./shuttle.jpeg": 7474,
	"./stampss.jpeg": 6790,
	"./taiwan.webp": 2622,
	"./thailand.webp": 1305,
	"./uae.jpg": 3089,
	"./uae.webp": 3511,
	"./vietnam.jpg": 554,
	"./waxseal.jpg": 7469,
	"./whatsapp.png": 650,
	"./worldmap.jpg": 7970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8849;